<template>
  <ul class="list-inline mb-0">
    <li v-for="account in socialAccounts" :key="account.id" class="list-inline-item">
      <a :href="account.url" target="_blank" v-on:click="trackEvent(account.company)">
        <i :class="['fa fa-2x', 'fa-' + account.company]"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {
      socialAccounts: [
        {
          company: 'twitter', /* Used for font-awesome icon */
          url: 'https://twitter.com/hansfbaier' /* URL for social account */
        }
      ]
    }
  },
  methods: {
    trackEvent (title) {
      this.$ga.event({
        eventCategory: 'sociallinktracking',
        eventAction: title,
        eventLabel: ''
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/SocialLinks.vue